import React from 'react';
import getFormattedValue from 'store/redux/utils/getFormattedValue';

const SpentFormatter = ({ row = {}, fontSize = 'sm', fontWeight = 'normal' }) => {
  const { ad_spent = 0 } = row;

  return (
    <span className={`text-${fontSize} font-${fontWeight} rounded-[14px] text-error`}>
      {getFormattedValue(ad_spent)}
    </span>
  );
};

export default SpentFormatter;
